/* The ways an order can be paid — shared by the order form's payment
   select and the preview's "Paid" dialog, so the two can't drift apart.
   Retail (the old RecurringInputPage) offers fewer than funerals. */

export const UNPAID = "**UNPAID**";

export const PAYMENT_OPTIONS = [
  "Eftpos/Credit Card",
  "Invoice Family Direct",
  "Account",
  UNPAID,
];

export const RETAIL_PAYMENT_OPTIONS = ["Eftpos/Credit Card", "Account", UNPAID];

/** The methods an order of this type can be marked paid with. */
export const paidMethodsFor = (type) =>
  (type === "Retail" ? RETAIL_PAYMENT_OPTIONS : PAYMENT_OPTIONS).filter(
    (o) => o !== UNPAID
  );
